import { Box } from '@mui/material';
import React from 'react';
import { themeColors } from '../JuvareTheme';
import { CardAction, CardContent, CardIcon } from './components';
export const Card = (props) => {
    return (React.createElement(Box, { sx: {
            display: 'grid',
            gridTemplateColumns: props.icon ? '80px 1fr auto' : '1fr auto',
            backgroundColor: themeColors.surface.primary,
            border: 1,
            minHeight: 80,
            borderRadius: 1,
            borderColor: themeColors.border.main,
            '&:hover': {
                boxShadow: 4,
                transition: '150ms ease-in-out',
            },
            transition: '150ms ease-in-out',
        }, "data-test": props['data-test'] },
        props.icon ? React.createElement(CardIcon, { iconColor: props.iconColor, icon: props.icon }) : null,
        React.createElement(CardContent, { title: props.contentTitle, badge: props.contentBadge, inlineBadge: props.contentTitleBadge, featureIcons: props.featureIcons, onClick: props.onContentClick, ariaLabel: props.contentAriaLabel }),
        props.actionIcon ? (React.createElement(CardAction, { icon: props.actionIcon, ariaLabel: props.actionAriaLabel, onClick: props.onActionClick })) : null));
};
